<template>
    <v-dialog v-model="dialog" max-width="500px">
        <v-card>
            <v-card-title
                class="text-h5 aviso"
            >
                Editar línea
            </v-card-title>
            <v-card-text style="text-align: center">
                <v-form ref="form" v-model="valid">
                    <v-row>
                        <v-col cols="12">
                            <v-text-field
                                v-model="linea.descripcion"
                                label="Descripción"
                                :rules="[rules.required]"
                            >
                            </v-text-field>
                        </v-col>

                        <v-col cols="12" md="4">
                            <div class="spacing">
                                <v-text-field-comma
                                    v-model="linea.cantidad"
                                    type="number"
                                    label="Cantidad"
                                    :rules="[rules.required, rules.min]"
                                >
                                </v-text-field-comma>
                            </div>
                        </v-col>
                        <v-col cols="12" md="4">
                            <div class="spacing">
                                <v-text-field-comma
                                    v-model="linea.importe"
                                    type="number"
                                    label="Importe"
                                    :rules="[rules.required, rules.min]"
                                >
                                </v-text-field-comma>
                            </div>
                        </v-col>

                        <v-col cols="12" md="4">
                            <v-autocomplete
                                v-model="
                                    linea.id_iva
                                "
                                label="IVA"
                                :items="items_select"
                                item-text="descripcion"
                                item-value="id"
                                suffix="%"
                                :rules="[rules.required]"
                            >
                            </v-autocomplete>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-card-actions class="pt-3">
                <v-spacer></v-spacer>

                <v-btn color="success" large @click="confirm()">Modificar</v-btn>

                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
export default {
    props: [
        'value',
        'item',
        'items_select'
    ],
    data(){
        return {
            dialog: false,
            rules: {
                required: value => !!value || 'Requerido.',
                min: value => {
                    const minValue = 0;
                    return value > minValue || `El número debe ser mayor a ${minValue}.`;
                },
                number: value => /^[0-9]+$/.test(value) || 'Solo se permiten números.'
            },
            valid: true
        }
    },
    created(){
        // 
    },
    methods: {
        confirm(){
            this.$emit('edit', this.linea)
            this.dialog = false
        }
    },
    computed: {
        linea(){
            let val = this.item
            return val 
        }
    },
    watch: {
        value: function (val){
            this.dialog = val
        },
        dialog: function (val){
            this.$emit("input", val);
        }
    }
}
</script>